import * as CONST from '../../../constants';

export const assignOrder = (order) => {
  return async (dispatch) => {
    dispatch({ type: CONST.MAP_ASSIGN_ORDER, order });
  };
};
